import React, { Fragment, useMemo, useState } from "react";
import { PalletShippingInformationManualInput } from "./pallet-shipping-information-manual-input";
import { PalletShippingInformationPickupSlotInput } from "./pallet-shipping-information-pickup-slot-input";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { t } from "i18next";
import { PalletsListItem } from "../../pallets-list/pallets-list-item";
import { context } from "../../../../../context/context";
import { Permission } from "../../../../../context/permission";

interface IPalletShippingInformationInputProps {
    palletsList: PalletsListItem[];
    isTruckIdentifierRequired: boolean;
}

export const PalletShippingInformationInput = (props: IPalletShippingInformationInputProps) => {
    const isNewFlowEnabled = useMemo(() => context.hasPermission(Permission.FeaturePalletPickupSlotShipping), []);
    const [noPickupSlotAvailable, setNoPickupSlotAvailable] = useState(false);
    const [manualShipping, setManualShipping] = useState(!isNewFlowEnabled);

    const handleNoPickupAvailable = () => {
        setNoPickupSlotAvailable(true);
        if (isNewFlowEnabled) {
            setManualShipping(true);
        }
    };

    return <Fragment>
        {isNewFlowEnabled && noPickupSlotAvailable && <Typography className={"pallet-shipping-form__error"}>
            {t("components.pallet.shipping.noPickupSlotAvailableError")}
        </Typography>}
        {manualShipping ?
            <PalletShippingInformationManualInput isTruckIdentifierRequired={props.isTruckIdentifierRequired} /> :
            <PalletShippingInformationPickupSlotInput palletsList={props.palletsList}
                                                      onNoPickupAvailable={handleNoPickupAvailable} />}
        {!isNewFlowEnabled && <FormControlLabel label={t("components.pallet.shipping.manualShipping")}
                                                control={<Checkbox checked={manualShipping}
                                                                   onChange={(_event, checked) =>
                                                                       setManualShipping(checked)} />} />}
    </Fragment>;
};
